import React, {useContext} from "react";
import AscendBrand from "../../src/images/ascend.svg";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHomeLgAlt, faMedal, faSignOut} from "@fortawesome/pro-regular-svg-icons";
import {CardActionArea} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import {AppContext} from "../App";
import {BASE_URL} from '../env.json';
import {PRIVACY_POLICY} from "../utils/api";

function SideNav(){
    let history = useHistory();
    const context = useContext(AppContext);
    return(
        <div className={'side-nav'}>
            <div className={'brand'}>
                <img src={AscendBrand} alt="Ascend"/>
                <span>BY EVER ACCOUNTABLE</span>
            </div>

            <div className={'navigation'}>
                <CardActionArea className={'navigation-item'}
                     onClick={()=>{
                         history.push(`/home/${context.deviceId}/${context.recoveryId}`);
                     }}>
                    <FontAwesomeIcon className={'fa-icon-active'} icon={faHomeLgAlt} style={{fontSize: 24, paddingBottom: 4}} />
                    <span><strong>Home</strong></span>
                </CardActionArea>
                <CardActionArea className={'navigation-item'}
                    onClick={()=>{
                        window.location.replace(`${BASE_URL}ascend/logout`)
                    }}
                >
                    <FontAwesomeIcon className={'fa-icon'} icon={faSignOut} style={{fontSize: 24, paddingBottom: 4}} />
                    <span>Sign out</span>
                </CardActionArea>
            </div>
            <div className={'privacy-policy'}
                onClick={()=>{
                    window.open(PRIVACY_POLICY, "_blank");
                }}>
                Privacy Policy
            </div>

        </div>
    )
}

export default SideNav;